define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaFractionRemainingDomain = void 0;
    class WaFractionRemainingDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaFractionRemainingDomain.Half, value: "Half" },
                    { key: WaFractionRemainingDomain.AThird, value: "A third" },
                    { key: WaFractionRemainingDomain.AQuarter, value: "A quarter" },
                    { key: WaFractionRemainingDomain.ThreeQuarters, value: "Three-quarters" },
                    { key: WaFractionRemainingDomain.TwoThirds, value: "Two-thirds" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaFractionRemainingDomain.Half] = 0;
                this.KeyIndex[WaFractionRemainingDomain.AThird] = 1;
                this.KeyIndex[WaFractionRemainingDomain.AQuarter] = 2;
                this.KeyIndex[WaFractionRemainingDomain.ThreeQuarters] = 3;
                this.KeyIndex[WaFractionRemainingDomain.TwoThirds] = 4;
                this.ValueIndex = {};
                this.ValueIndex["Half"] = 0;
                this.ValueIndex["A third"] = 1;
                this.ValueIndex["A quarter"] = 2;
                this.ValueIndex["Three-quarters"] = 3;
                this.ValueIndex["Two-thirds"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaFractionRemainingDomain = WaFractionRemainingDomain;
    Object.defineProperty(WaFractionRemainingDomain, "Half", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaFractionRemainingDomain, "AThird", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaFractionRemainingDomain, "AQuarter", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaFractionRemainingDomain, "ThreeQuarters", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(WaFractionRemainingDomain, "TwoThirds", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(WaFractionRemainingDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
